module.exports = __webpack_public_path__ + "img/TLF_16-25.9042abea.svg";